import React from 'react';
import DimensionInfos from '../DimensionInfos';
import Img from '../../components/Img';
import open from '../../assets/images/canvas/openDoors.svg';
import close from '../../assets/images/canvas/closeDoors.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDoorsModeAction } from '../Configurator/actions/general';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../PiecesList/types';
import {
  makeSelectDisplaySchemaDimension,
  makeSelectOpenDoorsMode,
} from '../Configurator/selectors/general';
import RemoveShelfButton from './RemoveShelfButton';

// import styled from 'styled-components';

interface Props {
  hideDimensionInfo?: boolean;
}

interface StateProps {
  openDoorMode: boolean;
  displaySchemaDimension: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  openDoorMode: makeSelectOpenDoorsMode(),
  displaySchemaDimension: makeSelectDisplaySchemaDimension(),
});

const IconsBarCanvas = ({ hideDimensionInfo }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openDoorMode, displaySchemaDimension } = useSelector(stateSelector);

  return (
    <div className="absolute bottom-15 right-0 z-20">
      <div className="flex flex-col items-center">
        {!displaySchemaDimension && (
          <button
            onClick={() => {
              dispatch(openDoorsModeAction(!openDoorMode));
            }}
            className="flex flex-col items-center "
          >
            <RemoveShelfButton />
            {!openDoorMode ? (
              <>
                <Img src={open} alt={'open'} className="h-10 w-12" />
                <div className="text-sm -mt-1">{t('Open doors')}</div>
              </>
            ) : (
              <>
                <Img src={close} alt={'close'} className="h-10 w-12" />
                <div className="text-sm -mt-1">{t('Close doors')}</div>
              </>
            )}
          </button>
        )}
        {!hideDimensionInfo && <DimensionInfos />}
      </div>
    </div>
  );
};

export default IconsBarCanvas;
